import app from 'app';
import ready from 'utils/ready';
import collection from './collection/main';

app.add({
  collection,
});

ready(app.mount);
